/**
 * 订单列表查询 hint 触发追踪：5 分钟内出现 ≥ 2 次 listingQueryTooBroad 才显示。
 * 触发后永久显示直到页面刷新。4 个 Filter 共用同一 store，跨页面切换不重置。
 */

import { create } from 'zustand';

const SHOW_THRESHOLD = 2;
const SHOW_WINDOW_MS = 5 * 60 * 1000;
const MAX_TIMESTAMPS = 100;

// timestamps 不放 store（不需要触发 re-render），用闭包 module 级
let timestamps: number[] = [];

interface OrderListingHintState {
    visible: boolean;
    record: () => void;
}

export const useOrderListingHintStore = create<OrderListingHintState>((set, get) => ({
    visible: false,
    record: () => {
        if (get().visible) return;
        const now = Date.now();
        timestamps.push(now);
        if (timestamps.length > MAX_TIMESTAMPS) timestamps = timestamps.slice(-MAX_TIMESTAMPS);
        timestamps = timestamps.filter((t) => now - t <= SHOW_WINDOW_MS);
        if (timestamps.length < SHOW_THRESHOLD) return;
        set({ visible: true });
    },
}));

// 非 React 上下文（errorLink 等 Apollo Link）调用入口
export const recordListingTooBroad = (): void => useOrderListingHintStore.getState().record();
